import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useState } from 'react';
import Modal from './Modal';

/**
 * Renders the Auto-Designer in a full-window modal iframe.
 *
 * Mounted once near the app root (outside the routed page tree) so it keeps
 * working even if the component that launched it (e.g. a create-project
 * wizard) navigates away or unmounts. Any part of the app can trigger it via
 * `window.openAutoDesigner(url, { title })`.
 */
const AutoDesignerModal = () => {
    const [config, setConfig] = useState(null);

    const openAutoDesigner = useCallback((url, options = {}) => {
        if (!url) return;
        setConfig({ url, title: options.title || 'Auto-Designer' });
    }, []);

    useEffect(() => {
        window.openAutoDesigner = openAutoDesigner;
        return () => {
            if (window.openAutoDesigner === openAutoDesigner) {
                delete window.openAutoDesigner;
            }
        };
    }, [openAutoDesigner]);

    if (!config) return null;

    const handleClose = () => setConfig(null);

    const body = (
        <div className="auto-designer-modal-body">
            <div className="auto-designer-modal-header">
                <h3>{config.title}</h3>
                <a
                    href={config.url}
                    target="_blank"
                    rel="noreferrer"
                    className="auto-designer-modal-new-tab-link"
                >
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> <span>Open in new tab</span>
                </a>
            </div>
            <iframe src={config.url} title={config.title} className="auto-designer-modal-iframe" />
        </div>
    );

    return <Modal form={body} setIsModalOpen={handleClose} fullScreen />;
};

export default AutoDesignerModal;
